import { defineRecipe } from '@plurall/elo-v3';

export const strategicInsightsListRecipe = defineRecipe({
  className: 'strategic-insights-card__list',
  base: {
    display: 'grid',
    gridTemplateColumns: {
      base: 'minmax(0, 1fr)',
      md: 'repeat(2, minmax(0, 1fr))',
    },
    gap: 'gap.large',
    width: '100%',
  },
});

export const strategicInsightsItemCardRecipe = defineRecipe({
  className: 'strategic-insights-card__item-card',
  base: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    backgroundColor: 'background.primary',
    padding: 'padding.large',
    '&::before': {
      pointerEvents: 'none',
    },
  },
});

export const strategicInsightsItemRecipe = defineRecipe({
  className: 'strategic-insights-card__item',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'gap.large',
    height: '100%',
    minWidth: 0,
  },
});

export const strategicInsightsHeaderRecipe = defineRecipe({
  className: 'strategic-insights-card__header',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'gap.medium',
  },
});

export const strategicInsightsIconRecipe = defineRecipe({
  className: 'strategic-insights-card__icon',
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'size.44',
    height: 'size.44',
    flexShrink: 0,
    borderRadius: 'border.radius.xsmall',
  },
  variants: {
    tone: {
      information: {
        backgroundColor: 'background.feedback.information.primary.alpha',
        color: 'text.feedback.information',
      },
      warning: {
        backgroundColor: 'background.feedback.warning.primary.alpha',
        color: 'text.feedback.warning',
      },
    },
  },
});

export const strategicInsightsHeadingRecipe = defineRecipe({
  className: 'strategic-insights-card__heading',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'gap.4xsmall',
    minWidth: 0,
  },
});

export const strategicInsightsLabelRecipe = defineRecipe({
  className: 'strategic-insights-card__label',
  base: {
    margin: 0,
    color: 'text.primary',
    fontSize: 'font.size.medium',
    fontWeight: 'font.weight.semi.bold',
    lineHeight: 'font.line.height.short',
  },
});

export const strategicInsightsTitleRecipe = defineRecipe({
  className: 'strategic-insights-card__title',
  base: {
    margin: 0,
    color: 'text.tertiary',
    fontSize: 'font.size.small',
    fontWeight: 'font.weight.regular',
    lineHeight: 'font.line.height.short',
  },
});

export const strategicInsightsInsightRecipe = defineRecipe({
  className: 'strategic-insights-card__insight',
  base: {
    margin: 0,
    color: 'text.tertiary',
    fontSize: 'font.size.small',
    fontWeight: 'font.weight.regular',
    lineHeight: 'font.line.height.short',
  },
});

export const strategicInsightsRecommendationRecipe = defineRecipe({
  className: 'strategic-insights-card__recommendation',
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'gap.xsmall',
    marginTop: 'auto',
    padding: 'padding.large',
    borderRadius: 'border.radius.xsmall',
  },
  variants: {
    tone: {
      information: {
        backgroundColor: 'background.feedback.information.primary.alpha',
        color: 'text.feedback.information',
      },
      warning: {
        backgroundColor: 'background.feedback.warning.primary.alpha',
        color: 'text.feedback.warning',
      },
    },
  },
});

export const strategicInsightsRecommendationHeaderRecipe = defineRecipe({
  className: 'strategic-insights-card__recommendation-header',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'gap.xsmall',
  },
});

export const strategicInsightsRecommendationLabelRecipe = defineRecipe({
  className: 'strategic-insights-card__recommendation-label',
  base: {
    margin: 0,
    color: 'currentColor',
    fontSize: 'font.size.small',
    fontWeight: 'font.weight.semi.bold',
    lineHeight: 'font.line.height.short',
  },
});

export const strategicInsightsRecommendationTextRecipe = defineRecipe({
  className: 'strategic-insights-card__recommendation-text',
  base: {
    margin: 0,
    color: 'currentColor',
    fontSize: 'font.size.small',
    fontWeight: 'font.weight.regular',
    lineHeight: 'font.line.height.short',
  },
});
